import React, { useEffect, useState } from "react";
import AdminLTE, {
  Sidebar,
  Content,
  Row,
  Col,
  Box,
  Button,
  Inputs,
  Label,
  SimpleTable,
  Pagination,
} from "adminlte-2-react";
import _ from "lodash";
import controller from "./duck";
import controllerAusencias from "../ausencias/duck";
import { useSelector, useDispatch } from "react-redux";
import { responseSelector } from "../utils/helpers/selectors";
import { logger, thousandSeparator } from "../utils/utils";
import moment from "moment";
import config from "../config";
import queryString from "query-string";

const { Select2, Date, DateTime, Text } = Inputs;

function AmbientesList({ history, match }) {
  const dispatch = useDispatch();


  const modelAmbientes = useSelector((state) => state.ambientesByLocal);



  const [ambientes, setAmbientes] = useState(null);
  const [totalResultsAmbientes, setTotalResultsAmbientes] = useState(0);
  const [activePageAmbientes, setActivePageAmbientes] = useState(0);
  const [pageSizeAmbientes, setPageSizeAmbientes] = useState(5);

 



  useEffect(() => {
    const data = modelAmbientes?.data?.data;
    const error = modelAmbientes?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckAmbientesByLocal.actions.clear());
    }
    if (data) {
  
      setAmbientes(data.data.items);
      setTotalResultsAmbientes(data.data.total);

      dispatch(controller.duckAmbientesByLocal.actions.clear());
    }
  }, [modelAmbientes]);





  useEffect(() => {
    dispatch(
      controller.getAmbientesByLocalThunk(match.params.organizacion, 1, pageSizeAmbientes)
    );
  }, []);


  function handlePageAmbientes(page) {
    setActivePageAmbientes(page);
    setAmbientes([]);
    dispatch(
      controller.getAmbientesByLocalThunk(
        match.params.organizacion,
        page + 1,
        pageSizeAmbientes
      )
    );
  }






  return (
    <Content title="Ambientes" subTitle="Ambientes" browserTitle="Ambientes" show={false}>
      <Row>

 
          <Col md="8">
            <Box title="Ambientes">
              <Button
                type="primary"
                text="Agregar"
                pullRight={true}
                onClick={() =>
                  history.push(`/nuevoAmbiente/${match.params.organizacion}`)
                }
              />
              <div>
                <span>Total: {totalResultsAmbientes}</span>
              </div>
              {ambientes && ambientes.length > 0 ? (
                <SimpleTable
                hover={true}
                  data={ambientes.map((row, index) => {
                    return {
                      nombre: row.nombre,
                      estado: row.estado,
                      maxPersonas: row.maxPersonas,
                      editar: (
                        <Button
                          type="primary"
                          text="Editar"
                          onClick={() =>
                            history.push(`/editAmbiente/${row._id}`)
                          }
                        />
                      ),
                    };
                  })}
                  columns={[
                    { title: "Nombre", data: "nombre" },
                    { title: "Estado", data: "estado" },
                    { title: "Maximo de personas", data: "maxPersonas" },
                    { title: "Editar", data: "editar" },
                  ]}
                />
              ) : (
                <h4>No se han encontrado ambientes</h4>
              )}
              <Pagination
                activePage={activePageAmbientes}
                pageSize={pageSizeAmbientes}
                totalElements={totalResultsAmbientes}
                onChange={handlePageAmbientes}
                labels= {{
                  first: 'Primera',
                  last: 'Última',
                  previous: 'Anterior',
                  next: 'Siguiente',
                }}
              />
              <div>
                <span>Total: {totalResultsAmbientes}</span>
              </div>
            </Box>
          </Col>
      


      </Row>
    </Content>
  );
}

export default AmbientesList;
